// Idle-roam timing + device detection for the dock firefly companion.

/** Stationary timeout before the firefly leaves its anchor (5 minutes). */
export const FIREFLY_IDLE_ROAM_TIMEOUT_MS = 5 * 60 * 1000;

/** Mobile screen-roam target interval (gentle moves). */
export const FIREFLY_MOBILE_ROAM_STEP_MS = 8000;

export function isCoarsePointerDevice(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(pointer: coarse)").matches;
}

export function randomMobileRoamPoint(): { x: number; y: number } {
  const marginX = 48;
  const marginY = 72;
  const w = typeof window !== "undefined" ? window.innerWidth : 360;
  const h = typeof window !== "undefined" ? window.innerHeight : 640;
  return {
    x: marginX + Math.random() * Math.max(marginX, w - marginX * 2),
    y: marginY + Math.random() * Math.max(marginY, h - marginY * 2),
  };
}
